import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { permanentDataAtom } from "recoil/permanentDataAtom";
import { sendMessage } from "utils/webview";
import { extractHexColor } from "styles/hexOpacity";

// page background 와 status bar / 하단 safe area 영역의 색상을 동기화.
// - 모바일 Safari / Chrome: <html>/<body> background-color (viewport-fit=cover 에서
//   safe area 영역에 노출됨) + <meta theme-color> (status bar tint).
// - iOS / Android RN 인앱 webview: set_safearea_color 메시지로 native 측에서 채움.
// 셋 다 갱신해야 page bg 와 status bar / 하단 safe area 가 모두 일치.
// topColor: 상단(히어로)과 하단의 배경색이 다른 페이지에서 status bar 쪽
// (meta theme-color / native topColor)만 별도 색으로 지정. html/body 는
// backgroundColor 를 따르므로 상단 overscroll 순간에는 backgroundColor 가 보인다.
export default function useSafeAreaColor(
  backgroundColor: string | undefined,
  topColor?: string
) {
  const isInappWebview = useRecoilValue(permanentDataAtom)?.isWebview;

  useEffect(() => {
    if (!backgroundColor) return;
    const hex = extractHexColor(backgroundColor);
    if (!hex) return;
    const topHex = (topColor && extractHexColor(topColor)) || hex;

    if (isInappWebview) {
      sendMessage(
        JSON.stringify({
          event: "set_safearea_color",
          params: { topColor: topHex, bottomColor: hex },
        })
      );
    }

    let metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (!metaThemeColor) {
      metaThemeColor = document.createElement("meta");
      metaThemeColor.setAttribute("name", "theme-color");
      document.head.appendChild(metaThemeColor);
    }
    metaThemeColor.setAttribute("content", topHex);

    document.documentElement.style.backgroundColor = hex;
    document.body.style.backgroundColor = hex;
  }, [backgroundColor, topColor, isInappWebview]);
}
